class FreeBaggageAllowanceUIModel {
  constructor({
    carryOn = 0,
    checked = 0,
    carryOnWeightKG = '',
    carryOnWeightLB = '',
    checkedMaxWeight = 0,
    checkedWeightUnit = '',
    personal = 0,
  }) {
    this.carryOn = carryOn;
    this.checked = checked;
    this.personal = personal;
    this.carryOnWeightKG = carryOnWeightKG;
    this.carryOnWeightLB = carryOnWeightLB;
    this.checkedMaxWeight = checkedMaxWeight;
    this.checkedWeightUnit = checkedWeightUnit;
  }
}

export default FreeBaggageAllowanceUIModel;
